import React from 'react';
import Pagination from 'partial/components/Pagination';
import Table from 'partial/components/Table';
import { useReportsContext } from 'partial/wrappers/ReportsContext';

const labelClassName = 'whitespace-nowrap';
const contentClassName = 'whitespace-nowrap';

const format = [
  { label: 'ORGANIZATION NAME', key: 'organization_name' },
  { label: 'EMAIL', key: 'email' },
  { label: 'FIRST NAME', key: 'first_name' },
  { label: 'LAST NAME', key: 'last_name' },
  { label: 'MOBILE NUMBER', key: 'mobile_number' },
].map((item) => ({
  ...item,
  labelClassName,
  contentClassName,
}));

export default function ClientInformation() {
  const { isLoading, list, meta, setPage } = useReportsContext();

  return (
    <div className="flex flex-col gap-10 h-full min-h-[65vh]">
      <Table isLoading={isLoading} data={list} format={format} />
      {!isLoading && <Pagination value={meta} onChange={setPage} />}
    </div>
  );
}
